module.exports = __webpack_public_path__ + "img/LogOutOutlined.31d4552e.svg";